export enum SeriesTypeEnum {
  LINE = 'line',
  BAR = 'bar',
  PIE = 'pie',
  SCATTER = 'scatter',
  GAUGE = 'gauge',
  AREA = 'area'
}
